import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => {
  return (
    <motion.div 
      className="w-10 h-10 rounded-full bg-white dark:bg-gray-800 flex items-center justify-center shadow-md overflow-hidden"
      whileHover={{ scale: 1.1, rotate: 5 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
    >
      <span className="text-2xl" role="img" aria-label="Pet Logo">
        🐾
      </span>
    </motion.div>
  );
};

export default Logo;